(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiMyTrainingBankBook', taiMyTrainingBankBook);

    function taiMyTrainingBankBook() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingBankBookController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.bankBook.html',
            scope: {
                isFocus: '='
            }
        };
        return directive;
    }
    /* @ngInject */
    function taiMyTrainingBankBookController($q, trainingInnerService, $scope, $uibModal, modalService) {
        var vm = this;
        vm.yearChanged = yearChanged;
        vm.openYearSelector = openYearSelector;
        vm.isMobile = modalService.isMobile();
        onInit();

        function onInit() {
            vm.data = dataInit();
            vm.view = viewInit();
            $scope.$watch('vm.isFocus', function(newValue) {
                if (newValue === true) {
                    logicInit();
                }
            });
        }

        function dataInit() {
            var result = {
                years: [], //........年度下拉清單的矩陣
                year: 1970, //.......選取的年度
                remainPoint: 0, //...剩餘存摺點數
                bankBook: [], //.....當年度花費點數的課程
            };
            return result;
        }

        function viewInit() {
            var result = {
                bankBookEmpty: false, //.......訓練存摺點數為空
                isInited: false, //............是否被初始化過
                pageLoaded: false, //..........頁面讀取完畢
                pageLoading: false, //.........頁面讀取中
            };
            return result;
        }

        function logicInit() {
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //=====
            var promiseEvt = function() {
                vm.view.isInited = true;
                vm.data.years = trainingInnerService.getYears(2011);
                vm.data.year = vm.data.years[0];
            }();
            $q.when(promiseEvt)
                .then(function() {
                    return yearChanged();
                })
                .then(function() {
                    vm.view.pageLoaded = true;
                    vm.view.pageLoading = false;
                });
        }

        function loadBankBook(year) {
            // return trainingInnerService.loadLangs()
            //     .then(function (langs) {
            //         var bankBookItem = {
            //             remainPoint: null,
            //             bankBook: []
            //         };
            //         var promiseList = [];
            //         _.forEach(langs, function (lang) {
            //             promiseList.push(trainingInnerService.getBankBook(year, lang.langCode));
            //         });
            //         return $q.all(promiseList).then(function (data) {
            //             _.forEach(data, function (perReceiveData) {
            //                 if (!bankBookItem.remainPoint) {
            //                     bankBookItem.remainPoint = perReceiveData.remainPoint;
            //                 }
            //                 Array.prototype.push.apply(bankBookItem.bankBook, perReceiveData.bankBook);
            //             });
            //             return bankBookItem;
            //         });
            //     });
            return trainingInnerService.getBankBook(year, sessionStorage.getItem("userLang"));
        }

        function yearChanged() {
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //======
            var result =
                loadBankBook(vm.data.year)
                .then(function(bankBookItem) {
                    if (!bankBookItem) {
                        vm.data.remainPoint = 0;
                        vm.data.bankBook = {};
                        vm.view.bankBookEmpty = true;
                        return;
                    }
                    //取代sessionTime中的<br>
                    // _.forEach(bankBookItem, function(data) {
                    //     console.log('sTime:',data);
                    //     // data.courseTime = data.courseTime.replace(/\<br\>/ig, ' ');
                    //     // console.log('data:',data.courseTime);
                    // });
                    vm.data.remainPoint = bankBookItem.remainPoint;
                    vm.data.bankBook = bankBookItem.bankBook;
                    vm.view.bankBookEmpty = bankBookItem.bankBook.length < 1;
                    return true;
                }).then(function() {
                    vm.view.pageLoaded = true;
                    vm.view.pageLoading = false;
                });
            return result;
        }

        function openYearSelector() {
            vm.view.pageLoaded = true;
            vm.view.pageLoading = false;

            var result = modalService.openOptionSelector(vm.data.years, 'yrSelect',false);

            //這個則是接收傳回來的值
            result.result.then(function(data) {
                vm.data.year = data;
                loadBankBook(vm.data.year)
                    .then(function(bankBookItem) {
                        if (!bankBookItem) {
                            vm.data.remainPoint = 0;
                            vm.data.bankBook = {};
                            vm.view.bankBookEmpty = true;
                            return;
                        }
                        vm.data.remainPoint = bankBookItem.remainPoint;
                        vm.data.bankBook = bankBookItem.bankBook;
                        vm.view.bankBookEmpty = bankBookItem.bankBook.length < 1;
                        return true;
                    }).then(function() {
                        vm.view.pageLoaded = true;
                        vm.view.pageLoading = false;
                    });
            });
            return result;
        }
    }



})();